<template>
  <div class="sidebar-wedget-wrap">
    <div class="sidebar-wedget">
      <span class="top-title">البحث في المقالات</span>
      <form class="search-form position-relative z-1">
        <input type="text" class="form-control" placeholder="ابحث هنا..." />
        <button class="src-btn position-absolute top-50 end-0 translate-middle-y">
          <i class="ri-search-line"></i>
        </button>
      </form>
    </div>

    <div class="sidebar-wedget">
      <span class="top-title">مقالات شائعة</span>
      <ul class="ps-0 mb-0 list-unstyled popular-post">
        <li v-for="blog in popularBlogs" :key="blog.id">
          <RouterLink :to="`/blog-details/${blog.id}`" class="d-flex align-items-center">
            <div class="flex-shrink-0">
              <img :src="blog.image" :alt="blog.title" style="width: 80px; height: 60px; object-fit: cover;" />
            </div>
            <div class="flex-grow-1 ms-3">
              <div class="d-flex align-items-center mb-1">
                <i class="ti ti-calendar-week"></i>
                <span class="text-body ms-1">{{ blog.date }}</span>
              </div>
              <h4 style="font-size: 14px;">{{ blog.title }}</h4>
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>

    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
// نستورد نفس مصفوفة المقالات من ملف المقالات الرئيسي
// إذا كنت وضعت المصفوفة في ملف مستقل، استخدم هذا الاستيراد:
// import { allBlogs } from "@/data/blogData"; 

export default defineComponent({
  name: "SidebarWidget",
  setup() {
    // محاكاة للبيانات (يجب أن تتطابق مع البيانات الموجودة في صفحة المقالات)
    const allBlogs = [
      { id: 1, image: require("@/assets/images/blog-4.jpg"), title: "كيف تضبط إعدادات سيرفر الـ IPTV", date: "23 يناير، 2026" },
      { id: 2, image: require("@/assets/images/blog-2.jpg"), title: "أفضل مشغلات IPTV", date: "22 يناير، 2026" },
      { id: 3, image: require("@/assets/images/blog-3.jpg"), title: "دليلك الشامل لتركيب Fire TV", date: "21 يناير، 2026" },
    ];

    // عرض أول 3 مقالات فقط كأكثر المقالات شيوعاً
    const popularBlogs = computed(() => allBlogs.slice(0, 3));

    return { popularBlogs };
  },
});
</script>